import { makeAutoObservable, runInAction } from "mobx";

import { StockistPurchaseModel } from "../../../Common/DTOs/Purchase/StockistPurchaseModel";
import { orderAjaxController } from "../../../Common/Ajax/OrderAjaxController";

class OrderSubpageController {
  stockistOrders: StockistPurchaseModel[] = [];
  isStockistOrdersLoading = false;

  async fetchStockistOrders() {
    this.isStockistOrdersLoading = true;

    try {
      const orders = await orderAjaxController.getStockistOrders();

      runInAction(() => this.stockistOrders = orders.map(order => new StockistPurchaseModel(order)));
    } finally {
      runInAction(() => (this.isStockistOrdersLoading = false));
    }
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const orderSubpageController = new OrderSubpageController();